/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function(){
	return {
		layout: {
			type: 'genericPage',
			layoutPositioning: 'relative',
			pageSize: {
				width: 512,
				height: 1024
			},
			showGrid: false,
			snapGrid: false,
			snapObjects: false
		}
	};
});
